import React, { useEffect, useRef } from 'react';
import { CommentPostType } from '../../../types/enum/CommentPostType';

interface ShortsMediaEmojiCommentProps {
  clickEmoji: (emoji: string) => void;
  commentPostType: CommentPostType;
  tags: string;
  title: string;
  category: string;
  contentCreatorNm: string;
  time?: number;
  brightcoveId?: string;
  eventStatus?: 'ING' | 'END' | 'ALL';
  mediaContentType?: string;
  isNews?: boolean;
  isReply?: boolean; // 답글용 이모지인지 구분
}

const ShortsMediaEmojiComment = (props: ShortsMediaEmojiCommentProps) => {
  const emojiBoxRef = useRef<HTMLDivElement>(null);
  const emojiMoreRef = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    window.addEventListener('click', handleClose);
    return () => {
      window.removeEventListener('click', handleClose);
    };
  }, []);

  const handleClose = e => {
    if (!emojiMoreRef.current?.contains(e.target) && !emojiBoxRef.current?.contains(e.target))
      emojiBoxRef.current?.classList.remove('is-active');
  };

  const clickMore = e => {
    e.preventDefault();
    emojiBoxRef.current?.classList.toggle('is-active');
  };

  const clickEmoji = e => {
    e.preventDefault();
    props.clickEmoji(e.currentTarget.innerText);
  };

  const emojiList = ['😊','👍', '❤️'].map((emoji, idx) => (
    <li key={idx}>
      <a
        className="emoji_item"
        href="#"
        onClick={e => {
          clickEmoji(e);
        }}
      >
        {emoji}
      </a>
    </li>
  ));

  const emojiMore = [
    '😁',
    '😭',
    '❤️',
    '👍',
    '🍺',
    '👏',
    '😍',
    '😎',
    '🥇',
    '🎁',
    '🤭',
    '🥳',
    '😱',
    '🤩',
    '😵',
    '😷',
    '😥',
    '😝',
    '💯',
    '👌',
    '☀️',
    '☂️',
    '⛄️',
    '🍀',
    '🎮',
    '🎧',
    '📢',
    '🥄',
    '⚾',
    '🚙',
    '🧡',
    '💛',
    '💚',
    '💙',
    '💜',
    '🖤',
  ].map((emoji, idx) => (
    <li key={'more' + idx}>
      <a
        className="emoji_box_item"
        href="#"
        onClick={e => {
          clickEmoji(e);
        }}
      >
        {emoji}
      </a>
    </li>
  ));

  // 답글용 이모지 박스 스타일
  const replyEmojiBoxStyle = props.isReply ? {
    position: 'absolute' as const,
    top: '45px', // more 버튼 아래에 위치
    right: '40px', // 왼쪽으로 이동 (more 버튼 중앙 정렬)
    left: 'auto',
    bottom: 'auto',
    width: '300px',
    padding: '12px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 16px 48px 0 rgba(0, 0, 0, 0.15)',
    zIndex: 10
  } : {};

  return (
    <>
      <ul className="emoji_list">{emojiList}</ul>
      <a className="emoji_more" onClick={clickMore} ref={emojiMoreRef} href="#">
        <img src={props.isReply ? '/assets/images/icon/ico-imoji-more.png' : '/assets/images/icon/ico-emoji-more.svg'} alt="more" className="emoji_more_img" />
      </a>
      <div 
        className="emoji_box" 
        ref={emojiBoxRef}
        style={replyEmojiBoxStyle}
      >
        <ul className="emoji_box_list custom_scroll">{emojiMore}</ul>
      </div>
    </>
  );
};

export default ShortsMediaEmojiComment;
